// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckBox_fasting_container__185V5","selected":"CheckBox_fasting_selected__ZJlEl","customSizeSpan":"CheckBox_fasting_customSizeSpan__kY5cq"};